
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { GetUsersResponse } from "@/models/api/system/users";
import { SystemModule } from "@/store/modules/index";
import router from "@/router";

const systemModule = getModule(SystemModule);

interface DefaultField {
  key: string;
  label: string;
}



@Component
export default class AgentUsers extends Vue {
  @Prop()
  wantCallbacks: boolean;
  
  loading: boolean = false;
  users: Array<any> = [];
  pageNumber: number = 1;
  totalItems: number = 0;
  pageSize: number = 15;

  agentName: string = '';

  sortKey: string = "";
  includeInactive: boolean = false;
  searchName: string = "";
  sortDirection: number = 1;

  allItems: Array<any> = [];
  filteredItems: Array<any> = [];
  paginatedItems: Array<any> = [];
  
  @Prop()
  agentId: number | null

  @Prop({ default: true })
  showAgentName: boolean

  @Emit('editAgent')
  editAgent() {
    return null;
  }

  agents:any = new Set();
  

  fields: Array<any> = [
    {
      key: "firstName",
      label: "First Name"
    },
    {
      key: "lastName",
      label: "Last Name"
    },
    {
      key: "email",
      label: "Email Address"
    },
    {
      key: "phone",
      label: "Phone Number"
    },
    {
      key: "roleName",
      label: "Role"
    },
    {
      key: "isActive",
      label: "Active", 
      thStyle: { width: '10%', textAlign: 'center'}
    },
    {
      key: "actions",
      label: ""
    }
  ];

  setSort(fieldName: string) {
    if(this.sortKey === fieldName)
      this.sortDirection *= -1;

    this.sortKey = fieldName;
    this.allItems  = (this.allItems ?? []).sort( (a, b) => {
      
      let sortResults = 1;  
      if(a[this.sortKey] == b[this.sortKey])
        sortResults = 0;

      if(a[this.sortKey] < b[this.sortKey])
        sortResults = -1;

      return sortResults * this.sortDirection;
    });

    this.paginateUsers();
  }
  
  editUser(id: any) {
    if(this.wantCallbacks) {
        this.$emit("onAddUserClicked", id);
    } else {
      router.push(`/admin/users/${id??'create'}`);        
    }
  }
  
  created() {
    this.updateUsers();
  }

  handleSearch() {
    this.updateUsers()
  }

  @Watch("allItems")
  async onAllItemsLoaded() {
    await this.filterUsers();
  }

  @Watch("includeInactive")
  async includeInactiveChanged() {
    await this.filterUsers();
  }


  @Watch("searchName")
  filterUsers() {
    let regex = new RegExp( this.searchName, "i");

    this.filteredItems =  this.allItems
      .filter( item => !this.searchName || 
        regex.test( item.firstName ) || 
        regex.test( item.lastName ) || 
        regex.test( item.roleName ) || 
        regex.test( item.email ) || 
        regex.test( item.phone ) )
      .filter(item => item.isActive || this.includeInactive)

    this.pageNumber = 1;
    this.totalItems = this.filteredItems.length;
    this.paginateUsers()
  }

  @Watch("pageNumber")
  paginateUsers() {
    let filteredItems = 
      (this.filteredItems ?? [])
        .slice( (this.pageNumber -1) * this.pageSize, (this.pageNumber -1) * this.pageSize + this.pageSize -1 )
        .map(item => {return {...item}})
    
    if( !!this.searchName ) {
      let regex = new RegExp( this.searchName, "i");

      filteredItems.forEach(item => {
        if(item.firstName) item.firstName = item.firstName.replace(regex, `<b>$&</b>`)
        if(item.companyName) item.companyName = item.companyName.replace(regex, `<b>$&</b>`)
        if(item.lastName) item.lastName = item.lastName.replace(regex, `<b>$&</b>`)
        if(item.phone) item.phone = item.phone.replace(regex, `<b>$&</b>`)
        if(item.email) item.email = item.email.replace(regex, `<b>$&</b>`)
        if(item.roleName) item.roleName = item.roleName.replace(regex, `<b>$&</b>`)
        if(item.tollFreePhone) item.tollFreePhone = item.tollFreePhone.replace(regex, `<b>$&</b>`)
      });
    }

    this.agents = Array.from(new Set<string>(this.filteredItems.map(item => item.agentName)));
    this.paginatedItems  = filteredItems;
  }

  public async updateUsers() {
    this.loading = true;
    const response: GetUsersResponse = await systemModule.getAgentUsers({
      agentId: this.agentId,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    });
    

    this.allItems = response.items;
    this.totalItems = response.totalItems;

    if(this.allItems != null && this.totalItems>0) {
      this.agentName = this.allItems[0].agentName
    }
    if(!this.agentName) {
      this.agentName = "CDS Logistics"
    }

    this.loading = false;

    this.setSort("firstName");
  }

}
